module.exports = __webpack_public_path__ + "img/28-ABITO-SCOSTUMATA-U-ECRU-BIANCO-ECRU-GARZA1.f5d7ad32.jpg";